// Base clase for all stores.
var BaseStore = Px.Util.mixin(Px.Base, Px.ObservablePropertiesMixin(), Px.DeclarativeActionsMixin);

Px.BaseStore = BaseStore;
export default BaseStore;
